"use client";

import { useQuery } from "@tanstack/react-query";
import { fetchActiveTetrisEvent } from "@/utils/tetris-api";

export function useActiveTetrisEvent() {
  return useQuery({
    queryKey: ["tetris-event", "active"],
    queryFn: () => fetchActiveTetrisEvent(),
    staleTime: 30_000,
    refetchInterval: 30_000,
  });
}
